import { Icon, Label, List } from 'semantic-ui-react';
import React, { FunctionComponent } from 'react';
import {
  SemanticCOLORS,
  SemanticICONS,
} from 'semantic-ui-react/dist/commonjs/generic';

import { formatDateTime } from 'utils/date';

type Props = {
  date: string;
  color: SemanticCOLORS;
  text: string;
  icon: SemanticICONS;
};

const TimelineEmailAction: FunctionComponent<Props> = ({
  date,
  color,
  text,
  icon,
}) => (
  <List.Item>
    <Label
      color={color}
      horizontal
      size="large"
      style={{ width: '100px', textAlign: 'left' }}
    >
      <Icon name={icon} style={{ width: '15px' }} />
      {text}
    </Label>
    - {formatDateTime(date)}
  </List.Item>
);

export default TimelineEmailAction;
